import Vue from "vue";
import VueRouter from "vue-router";
import Portfolio from "@/views/Portfolio.vue";
import Trade from "@/views/Trade.vue";
import Curve from "@/views/Curve.vue";
import Risk from "@/views/Risk.vue";
import WhatIf from "@/views/WhatIf.vue";

import auth from "../app/auth";
import LogoutSuccess from "@/views/LogoutSuccess";
import UserInfoStore from "../app/user-info-store";
import UserInfoApi from "../app/user-info-api";
import ErrorComponent from "@/views/Error";

Vue.use(VueRouter);

function requireAuth(to, from, next) {
  if (!auth.auth.isUserSignedIn()) {
    UserInfoStore.setLoggedIn(false);
    next({
      path: "/login",
      query: { redirect: to.fullPath }
    });
  } else {
    UserInfoApi.getUserInfo().then(response => {
      UserInfoStore.setLoggedIn(true);
      UserInfoStore.setCognitoInfo(response);
      next();
    });
  }
}

const routes = [
  {
    path: "/",
    name: "home",
    component: Portfolio,
    beforeEnter: requireAuth
  },
  {
    path: "/portfolio",
    name: "portfolio",
    component: Portfolio,
    beforeEnter: requireAuth
  },
  {
    path: "/trade/:id",
    name: "trade",
    component: Trade,
    beforeEnter: requireAuth
  },
  {
    path: "/curve",
    name: "curve",
    component: Curve,
    beforeEnter: requireAuth
  },
  {
    path: "/risk",
    name: "risk",
    component: Risk,
    beforeEnter: requireAuth
  },
  {
    path: "/simulation",
    name: "simulation",
    component: WhatIf,
    beforeEnter: requireAuth
  },

  // THESE ARE THE AUTH ROUTES.
  {
    path: "/login",
    beforeEnter() {
      auth.auth.getSession();
    }
  },
  {
    path: "/login/oauth2/code/cognito",
    beforeEnter() {
      var currUrl = window.location.href;

      //console.log(currUrl);
      auth.auth.parseCognitoWebResponse(currUrl);
      //next();
    }
  },
  {
    path: "/logout",
    component: LogoutSuccess,
    beforeEnter(to, from, next) {
      auth.logout();
      next();
    }
  },
  {
    path: "/error",
    component: ErrorComponent
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
